// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5915fddb","667":"9ca49ad1"}[chunkId] + ".chunk.js";
};